import Vue from 'vue'
import Router from 'vue-router'

import wenjuan from '@/views/wenjuan'
import admin from '@/views/admin'
import mine from '@/views/mine'
import multiadmin from '@/views/multiadmin'
import feedback from '@/views/feedback'
import question from '@/views/user/question'
import dynamic from '@/views/user/dynamic'
import open from '@/views/open'
import paymoney from '@/views/paymoney'
import ttt from '@/views/ttt'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'wenjuan',
      component: wenjuan
    },
    {
      path: '/mine',
      name: 'mine',
      component: mine
    },

    {
      path: '/admin',
      name: 'admin',
      component: admin
    },
    {
      path: '/multiadmin',
      name: 'multiadmin',
      component: multiadmin
    },
    {
      path: '/question',
      name: 'question',
      component: question
    }, {
      path: '/feedback',
      name: 'feedback',
      component: feedback
    },
    {
      path: '/open',
      name: 'open',
      component: open
    },
    {
      path: '/dynamic',
      name: 'dynamic',
      component: dynamic
    },
    {
      path: '/paymoney',
      name: 'paymoney',
      component: paymoney
    },
    {
      path: '/ttt',
      name: 'ttt',
      component: ttt
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js